export default [
  {
    key: 'disableAllNotification',
    label: 'field.disableAllNotification',
    type: 'checkbox',
    rules: 'required',
    cols: 12,
  },
]
